import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Constants } from '@shared';

const ResendWelcomeInfo = () => {

    const location = useLocation(), navigate = useNavigate();
    const { state: { email } } = location;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">Check your email</h1>
            <div className="content-box shadow-sb items-start pb-7">
                <p className="page-subheader text-left">
                    Thank you! If we have an account for <b>{email}</b>, we’ll send an email from <b>mailer@suboundhomes.com</b>. Click the link in that email to create your Sunbound account.
                </p>
                <span className="page-subheader text-left">Still having trouble? Call <a href={`tel:${Constants.Help.Phone}`} className="underline">{Constants.Help.Phone}</a> or email <a href={`mailto:${Constants.Help.Email}`} className="underline">{Constants.Help.Email}</a></span>
            </div>
            <div className="w-full">
                <button
                    className="btn btn-primary h-14 mt-7 text-lg font-bold rounded-full"
                    type="button"
                    onClick={() => navigate(`/`)}>
                    Back to login
                </button>
            </div>
        </div>
    );
};

export default ResendWelcomeInfo;